import { customizeCraftJsComponent } from '../../helpers';
import { EditorInput } from '../EditorInput';

export const EditorTenantDomainInput = customizeCraftJsComponent(EditorInput, {
	name: 'Tenant Domain',
	props: {
		name: 'tenantDomain',
		placeholder: 'Tenant Domain',
		label: 'Tenant Domain'
	}
});
